import { Injectable } from '@angular/core';
import { SCALE } from 'src/app/data/scale';
import { Scale } from 'src/app/model/scale';
import { BehaviorSubject } from 'rxjs';
import { ElementsService } from './elements.service';


@Injectable({
  providedIn: 'root'
})
export class ScaleService {
  
  private readonly _scale= new BehaviorSubject<Scale>(SCALE);
  private _currentScale: Scale = SCALE;
  scale$ = this._scale.asObservable();

  constructor(
    private elementsService: ElementsService
    ) { 
    this._currentScale=SCALE;
  }

  changeScale(how:string){
    let ratio : number = this._currentScale.screen.step/this._currentScale.screen.meters;
    
    if(how==='+'){
      
      // if(this._currentScale.screen.step>=this._currentScale.screen.meters)
      if(0.2>=this._currentScale.screen.meters)
        return false;
        
      this._currentScale.screen.meters=Math.round((this._currentScale.screen.meters-this._currentScale.screen.step)*100)/100;

    }else if(how==='-'){ 
      this._currentScale.screen.meters=Math.round((this._currentScale.screen.meters+this._currentScale.screen.step)*100)/100;   

      // this._currentScale.screen.offset.left=this._currentScale.screen.offset.left;
      // this._currentScale.screen.offset.top=this._currentScale.screen.offset.top;
      // console.warn(this._currentScale.screen.offset,this._currentScale.screen.ratio)  

    }else if(how==='0'){        
      this._currentScale.screen.meters=this._currentScale.screen.default.meters;
      this._currentScale.screen.metersPerPx=this._currentScale.screen.default.metersPerPx;
      this._currentScale.screen.pixels=this._currentScale.screen.default.pixels;
    }
    this._currentScale.screen.metersPerPx=this._currentScale.screen.meters/this._currentScale.screen.pixels;
    let changeRatio=this._currentScale.screen.ratio;
    this._currentScale.screen.ratio=1/this._currentScale.screen.meters
    changeRatio=this._currentScale.screen.ratio/changeRatio;
    this._scale.next(this._currentScale);
  }

  changeScaleByRatio(newRatio,offset=null){

    this._currentScale.screen.ratio=newRatio;
    this._currentScale.screen.metersPerPx=this._currentScale.screen.default.metersPerPx/newRatio;
    this._currentScale.screen.meters=this._currentScale.screen.metersPerPx*this._currentScale.screen.pixels;
    // this._currentScale.screen.meters=1/newRatio
    if(offset){
      this._currentScale.screen.offset=offset;
    }
    this._scale.next(this._currentScale);
  }

  setMetersPerPx(metersPerPx:number){
    this._currentScale.screen.metersPerPx=metersPerPx;

    this._currentScale.screen.meters=this._currentScale.screen.pixels*metersPerPx;
    this._currentScale.screen.ratio=1/this._currentScale.screen.meters
    this._scale.next(this._currentScale);
  }

  getProcessedSizes(){
    let data=this._currentScale.screen;
    // let roundedMeters : number =parseFloat(data.meters.toFixed(1));
    let roundedMeters : number =Math.floor(data.meters);
    let metersDifference: number=Math.abs(data.meters - roundedMeters);
    let pxDiff=metersDifference/data.metersPerPx;
    let result={
      metersPerPx:data.metersPerPx,
      pixels:data.pixels-pxDiff,
      meters: Math.round((data.meters-metersDifference)*100)/100
    }
    if(!result.meters){
      roundedMeters =Math.floor(data.meters*10);
      metersDifference=Math.abs(data.meters*10 - roundedMeters);
      pxDiff=metersDifference/10/data.metersPerPx;
      result.meters=Math.round((data.meters-metersDifference/10)*10)/10
      result.pixels=data.pixels-pxDiff;
    }

    return result
  }

  fitScale(){
    let projectCoords=this.getZonesExtremas();
    if(!projectCoords)
      return false;

    let projectW=this.countPixelLength(projectCoords[0].x,projectCoords[1].x)
    let projectH=this.countPixelLength(projectCoords[0].y,projectCoords[1].y)
    
    let windowW = window.innerWidth;
    let windowH = window.innerHeight;

    let projectProportions=projectW/projectH;
    let windowProportions=windowW/windowH;
    let newRatio=null;
    if(projectProportions>windowProportions){
      newRatio=windowW*0.7/projectW
    }else{
      newRatio=windowH*0.7/projectH
    }
    let offset={
      left:(projectCoords[0].x*newRatio-windowW*0.15),
      top:(projectCoords[0].y*newRatio-windowH*0.15),
    }
    this.changeScaleByRatio(newRatio,offset)
  }


  countPixelLength(begin,end){
    return (end-begin);
  }

  getZonesExtremas(){
    let zones=this.elementsService.getZones();
    let contour=this.elementsService.getContour();
    let zonesExtremas=[]
    let extremaX,extremaY;
    if(zones.length==0 && !contour)
      return null;

    if(contour){
      extremaX=this.getMinMax(contour.points,'x');
      extremaY=this.getMinMax(contour.points,'y');
      zonesExtremas.push({x:extremaX.min,y:extremaY.min})
      zonesExtremas.push({x:extremaX.max,y:extremaY.max})    
    }
    for(let i=0;i<zones.length;i++){
      extremaX=this.getMinMax(zones[i].points,'x');
      extremaY=this.getMinMax(zones[i].points,'y');
      zonesExtremas.push({x:extremaX.min,y:extremaY.min})
      zonesExtremas.push({x:extremaX.max,y:extremaY.max})
    }
    let finalExtremasX=this.getMinMax(zonesExtremas,'x')
    let finalExtremasY=this.getMinMax(zonesExtremas,'y')
    let finalExtremas=[
      {x:finalExtremasX.min,y:finalExtremasY.min},
      {x:finalExtremasX.max,y:finalExtremasY.max}
    ]
    
    return finalExtremas;
  }

  getMinMax(setOfPoints,axis){
    let min=null;
    let max=null;
    for(let i=0;i<setOfPoints.length;i++){
      if(min==null || min>setOfPoints[i][axis])
        min=setOfPoints[i][axis];
      
      if(max==null || max<setOfPoints[i][axis])
        max=setOfPoints[i][axis];
    }

    return {min:min,max:max};
  }

}
